module.exports = __webpack_public_path__ + "img/opening-column-right.4639f83d.svg";